module.exports = {"350213001":"大嶝街道","350213102":"马巷镇","350213103":"新圩镇","350213104":"新店镇","350213111":"内厝镇","350213404":"大帽山农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350213.json
// module id = 1083
// module chunks = 0